import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=5c52f786&scoped=true&"
import script from "./MobileBanner.vue?vue&type=script&lang=js&"
export * from "./MobileBanner.vue?vue&type=script&lang=js&"
import style0 from "./MobileBanner.vue?vue&type=style&index=0&id=5c52f786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52f786",
  null
  
)

export default component.exports